import { BaseRouteService } from "core/services";

class FacilityInventoryCalculationRouteService extends BaseRouteService {
	constructor() {
		super("facility-inventory-calculations");	
	}	
	
	get(id, options) {		
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);	
	}	
	
	create(resource) {		
		return super.create(this.base, resource);	
	}

    newFlowCreate(resource) {		
        return super.create(`${this.base}/new-flow`, resource);	
	}

    nikoFlowCreate(resource) {		
        return super.create(`${this.base}/niko-flow`, resource);	
	}

	getExisting(facilityOrderId){
        return super.get(this.base + '/existing/{facilityOrderId}', null, {
            facilityOrderId: facilityOrderId
        })
    }

	refresh(id){
        return super.get(this.base + '/refresh/{id}', null, {
            id: id
        })
    }

    newFlowRefresh(id){
        return super.get(this.base + '/refresh/new-flow/{id}', null, {
            id: id
        })
    }

    nikoFlowRefresh(id){
        return super.get(this.base + '/refresh/niko-flow/{id}', null, {
            id: id
        })
    }

	process(id){
        return super.get(this.base + '/process/{id}', null, {
            id: id
        })
    }

	newFlowProcess(id){
        return super.get(this.base + '/process/new-flow/{id}', null, {
            id: id
        })
    }

    nikoFlowProcess(id){
        return super.get(this.base + '/process/niko-flow/{id}', null, {
            id: id
        })
    }
}

export default FacilityInventoryCalculationRouteService;